$(document).ready(function(){
    var getPostalCodeStorage = localStorage.getItem('postal-code');
    var blockPostCodeTitle = $(".announcement-header__block-post-code-title");
    var blockPostCode = $(".announcement-header__block-post-code");
    var deliveryInput = $(".delivery-input input");

    if (blockPostCodeTitle) {
        blockPostCodeTitle.click(function(){
            blockPostCode.css("display", "flex");
            blockPostCodeTitle.css("display", "none");
        });
    }
    if(blockPostCode) {
        blockPostCode.val(getPostalCodeStorage);
        deliveryInput.val(getPostalCodeStorage)
    }
    
    if(getPostalCodeStorage) {
        fetchData(getPostalCodeStorage);
    }else {
        blockPostCodeTitle.css("display", "flex");
    }

    const $postcodeInput = $('.announcement-header__block-post-code input');
    const $textEnterButton = $('.announcement-header__block-post-code .text-enter');
    const $deliveryValidatorInput = $('#zapiet-delivery-validator__postal_code');
    const $deliverySubmitButton = $('.zapiet-delivery-validator__submit');

    const $deliveryButton = $('.delivery-button');
    const $deliveryAlert = $('.delivery-alert');

    $deliveryButton.on('click', function() {
        const postcodeValue = deliveryInput.val();
        localStorage.setItem('postal-code', postcodeValue);

        const savedPostcode = localStorage.getItem('postal-code');
        if (savedPostcode) {
            $deliveryValidatorInput.val(savedPostcode);
            fetchData(savedPostcode);
            funcBtnSchedule(savedPostcode);
        }
        $deliverySubmitButton.click();
    });

    $postcodeInput.on('keydown', function (event) {
        if (event.key === 'Enter') {
            handlePostalCodeSubmit();
        }
    });
    
    $textEnterButton.on('click', handlePostalCodeSubmit);

    function handlePostalCodeSubmit() {
        const postcodeValue = $postcodeInput.val();
        localStorage.setItem('postal-code', postcodeValue);

        const savedPostcode = localStorage.getItem('postal-code');
        if (savedPostcode) {
            $deliveryValidatorInput.val(savedPostcode);
            fetchData(savedPostcode);
            funcBtnSchedule(savedPostcode);
            setTimeout(() => {
                deliveryInput.val(savedPostcode)
            },1000)
        }
        $deliverySubmitButton.click();
    }

    async function fetchData(getPostcode) {
        const urlHostZapiet = 'https://api-us.zapiet.com';
        const apiDelivery = '/v1.0/delivery/locations?api_key=e9f141290d7534af3f3c950757fd6f01&shop=efoodz-au.myshopify.com';
        const geoSearchQuery = {
            "geoSearchQuery": getPostcode
        };
        try {
            const response = await fetch(`${urlHostZapiet}${apiDelivery}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(geoSearchQuery)
            });

            const data = await response.json();
            let timeBreakpointTranform = '';
            let dayBreakpoint = '';
            if(!data.error) {
                if (data.id) {
                    const apiCalendar = `/v1.0/delivery/locations/${data.id}/calendar?api_key=e9f141290d7534af3f3c950757fd6f01&shop=efoodz-au.myshopify.com`;
                    const calendarResponse = await fetch(`${urlHostZapiet}${apiCalendar}`, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    });
                    const calendarData = await calendarResponse.json();
                    
                    const minDateTime = formatMinDateTime(calendarData.minDateTime);
    
                    if (data.delivery) {
                        const schedule = data.delivery;
                        const today = new Date();
                        const dayOfWeekMap = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
                        const todayName = dayOfWeekMap[today.getDay()];
                        
                        const todaySchedule = schedule[todayName];
                        const beforeValue = todaySchedule.before.value;
                        const nextDate = new Date(today);
                        nextDate.setDate(today.getDate() + beforeValue);
                        const nextDayName = dayOfWeekMap[nextDate.getDay()];

                        timeBreakpointTranform = convertTo12HourFormat(todaySchedule.breakpoint);
                        dayBreakpoint = todayName;
                    }
                    if(getPostcode) {
                        blockPostCodeTitle.css("display", "none");
                        blockPostCode.css("display", "none");
                        $("#header-zapiet").css("display", "flex");
                        $("#header-zapiet .header-zapiet-edit").click(function(){
                            blockPostCode.css("display", "flex");
                            $("#header-zapiet").css("display", "none");
                        });
                        if($("#header-zapiet .header-zapiet-text").length){
                            $("#header-zapiet .header-zapiet-text").html(`Order by <strong class="text-capitalize">${dayBreakpoint}</strong> <strong>${timeBreakpointTranform}</strong>, earliest delivery is on <strong>${minDateTime}</strong> to <strong>${getPostcode}</strong>`);
                        }
                    }else {
                        $("#header-zapiet").css("display", "none");
                        blockPostCodeTitle.css("display", "flex");
                    }
                }
            } else {
                blockPostCodeTitle.css("display", "flex");
                blockPostCode.css("display", "none");
                $("#header-zapiet").css("display", "none");
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }

    async function funcBtnSchedule(getPostcode) {
        const urlHostZapiet = 'https://api-us.zapiet.com';
        const apiDelivery = '/v1.0/delivery/locations?api_key=e9f141290d7534af3f3c950757fd6f01&shop=efoodz-au.myshopify.com';
        const geoSearchQuery = {
            "geoSearchQuery": getPostcode
        };
        try {
            const response = await fetch(`${urlHostZapiet}${apiDelivery}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(geoSearchQuery)
            });
            const data = await response.json();
            let timeBreakpointTranform = '';
            let dayBreakpoint = '';
            if(!data.error) {
                if (data.id) {
                    const apiCalendar = `/v1.0/delivery/locations/${data.id}/calendar?api_key=e9f141290d7534af3f3c950757fd6f01&shop=efoodz-au.myshopify.com`;
                    const calendarResponse = await fetch(`${urlHostZapiet}${apiCalendar}`, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    });
                    const calendarData = await calendarResponse.json();
                    
                    const minDateTime = formatMinDateTime(calendarData.minDateTime);
    
                    if (data.delivery) {
                        const schedule = data.delivery;
                        const today = new Date();
                        const dayOfWeekMap = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
                        const todayName = dayOfWeekMap[today.getDay()];
                        
                        const todaySchedule = schedule[todayName];
                        const beforeValue = todaySchedule.before.value;
                        const nextDate = new Date(today);
                        nextDate.setDate(today.getDate() + beforeValue);

                        timeBreakpointTranform = convertTo12HourFormat(todaySchedule.breakpoint);
                        dayBreakpoint = todayName;
                    }
                    if(getPostcode) {
                        if($deliveryAlert.length){
                            $deliveryAlert.html(`Order by <strong class="text-capitalize">${dayBreakpoint}</strong> <strong>${timeBreakpointTranform}</strong>, earliest delivery is on <strong>${minDateTime}</strong> to <strong>${getPostcode}</strong>`);
                        }
                    }
                }
            }else {
                $deliveryAlert.text('Your Delivery Postcode is incorrect')
            }
            
        } catch (error) {
            console.error('Error:', error);
        }
    }

    function convertTo12HourFormat(time24) {
        let [hours, minutes] = time24.split(':');
        hours = parseInt(hours, 10);
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        return `${hours}${ampm}`;
    }

    function formatMinDateTime(minDateTimeStr) {
        const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        const date = new Date(minDateTimeStr);
        const dayOfWeek = daysOfWeek[date.getUTCDay()];
        let hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        const formattedMinutes = minutes.toString().padStart(2, '0');
        const formattedTime = `${hours}:${formattedMinutes}${ampm}`;
        return `${dayOfWeek}`;
    }

    // Handle zapiet cart page
    $('.cart__footer #checkout_temp').click(function(e){
        e.preventDefault();
        const deliveryGeoSearchField = $('#deliveryGeoSearchField');
        const dateField = $('#Zapiet-InputCalendar__delivery');

        if (!deliveryGeoSearchField || dateField.val()) {
            $( ".cart__footer #checkout_temp" ).css('display', 'none');
            $( ".cart__footer #checkout" ).css('display', 'block');
            $( ".cart__footer #checkout" ).trigger( "click" );
        }
    });
})